












































































































































































































































































































import _, { toNumber } from 'lodash';
import { PageMode } from '@/main/utils/pageMode';
import { PageModeMixin } from '@/main/mixins/pageMode';
import { EditStoreMixin } from '@/main/pages/editStoreMixin';
import { openEdit, openList } from '@/main/router/routerPath';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { Column, Table, getColumnsRowMapObject, Row, cellNames, intToRgb, EditableStatus } from '@/main/utils/table';
import { TABLE_DATA, START_LOADING, END_LOADING } from '@/main/store/listEditTypes';
import { EventBus } from '@/main/eventBus';
import { apiProvider as zakazkaApiProvider } from '@/modules/servis/zakazka/api';
import { createButton } from '@/main/utils/tableOperations';

import { UserRole, VehicleBrand, ScreenSize } from '@/main/components/constants';
import { showAlert, MessageTypeStatus, getMessageType } from '@/main/utils/notifications';
import { DropdownItem, WorkersWithCostCenter } from '@/main/store/@types/dropdown.d';

import DmsEditableTable from '#components/dms/layout/EditableTable.vue';

import { editActions } from './store/types';
import { apiProvider } from './api';
import { NAME, ZAKAZKA_PP, SPLIT_BILLING, LABOUR, LABOR_COLS, MAX_DISCOUNT_LIMIT, MIN_DISCOUNT_LIMIT, MIN_FIELD_LEVEL, MAX_SHARE_PERCENTAGE, CHARGE_GROUP_CHANGED, LO_SAVED, BULK_UPLOAD, ROW_EDIT_CLICKED } from './constants';
import { PRACOVNI_POZICE, ZAKAZKA_DRUH, ZAKAZKA_STAV, LINE_ITEM_STATUS, SAVE_ORDER } from '../constants';
import { SPLIT_PARTIES } from '../ServiceJobSplitBilling/constants';
import { store } from '../store/edit';
import { getStavZakazka } from '../utils';


export default EditStoreMixin.extend({
	name: 'PracovniPoziceCard',
	components: {
		DmsEditableTable,
	},
	data() {
		return {
			noteInput: '',
			selectedLaborNumber: '',
			screenSize: ScreenSize.TABLET,
			windowWidth: window.innerWidth,
			applyDiscount: false,
			showCancelOrderDialog: false,
			showSplitSharesDialog: false,
			rowId: 0,
			showDiscountSection: false,
			dialogHeaderText: '',
			splitShareDialogHeaderText: 'Split Share Details',
			multipleSelection: [],
			multipleSelectionLaborRevert: [],
			laborValue: 0,
			showLaborsDialog: {
				visible: false,
				title: null as string | null,
				extraButtons: null as object | null,
				handleClose: () => {},
			},
			laborFileList: [] as any[],
			table: [],
			tableKey: '0',
			loading: true,
			totalDiscount: 0,
			laborCols: LABOR_COLS,
			localTimeUnit: 0 as number | null,
			cancelLocalTimeUnit: 0 as number | null,
			localLaborPrice: null as number | null,
			cancelLocalLaborPrice: null as number | null,
			localCostCenter: null as number | null,
			cancelCostCenter: null as number | null,
			showDelete: false,
			showRevert: false,
			isDiscountEditable: true,
			isElementEditable: true,
			timeout: null as any | null,
			warrantyPriceInput: '',
			cancelWarrantyPriceInput: '',
			canEditWarrantyPrice: false,
			originalDiscountPercent: null as number | null,
			originalDiscountAmount: null as number | null,
			discountAmountReverted: false,
		};
	},
	props: {
		storeUri: { type: String, default: null, required: true },

	},
	mounted() {
		this.refreshTable(ZAKAZKA_PP);
		EventBus.$on(SAVE_ORDER, this.handleOrderSaved);
	},
	beforeDestroy() {
		EventBus.$off(SAVE_ORDER, this.handleOrderSaved);
	},
	computed: {
		getWidth() :string {
			return this.windowWidth <= this.screenSize ? ScreenSize.DIALOG_TABLET_WIDTH : ScreenSize.DIALOG_DEFAULT_WIDTH;
		},
		...genVuexComputeds(store),
		zakazkaStav(): ZAKAZKA_STAV {
			return getStavZakazka(this.edit);
		},
		pracovniPoziceTable(): any {
			this.disableColumns(this.dependentTables.ZakazkaPracovniPozice);
			let idColumn: number;
			_.forEach(this.dependentTables.ZakazkaPracovniPozice.columns, (col: Column) => {
				if (col?.columnId !== null) { idColumn = toNumber(col?.columnId); } else {
					col.columnId = (idColumn + 1).toString();
					idColumn = toNumber(col.columnId);
				}
			});
			return this.dependentTables.ZakazkaPracovniPozice;
		},
		pracovniPoziceName(): string {
			return NAME;
		},
		pracovniPoziceFilter(): object {
			return {
				ZakazkaId: this.ZakazkaId,
			};
		},
		zakazkaExists(): boolean {
			return this.ZakazkaId! > 0;
		},
		isApprovalDisabled(): boolean {
			return !(this.dependentTables.ZakazkaPracovniPozice.rows.length > 0);
		},
		extraButtons(): {} {
			if (this.dmsSys.OrderDiscountPrp) {
				return { ...createButton(this.labourDiscount) };
			}
			return {};
		},
		isAdditionalVisible(): boolean {
			return this.edit.IsAllItemLevelStatusEntered!;
		},
		isDiscountEnabled(): boolean {
			return (this.ZakazkaDruh !== ZAKAZKA_DRUH.GARANCE);
		},
		canEditTableInReleaseMode(): boolean {
			return ((this.isSplitBillingAvailableForOrderType() || this.ZakazkaDruh === ZAKAZKA_DRUH.GARANCE || this.ZakazkaDruh === ZAKAZKA_DRUH.KULANCE)
			&& (this.zakazkaStav === ZAKAZKA_STAV.OTEVRENA || this.zakazkaStav === ZAKAZKA_STAV.UVOLNENA || this.zakazkaStav === ZAKAZKA_STAV.NABIDKA));
		},
		tableDisabled(): boolean {
			let isReleasedOrder = false;
			if (this.edit.UvolneniDat !== null && this.edit.UzavreniDat === null && !this.isSplitBillingAvailableForOrderType()) {
				isReleasedOrder = true;
			}
			return this.isViewMode || isReleasedOrder;
		},
	},
	watch: {
		pracovniPoziceTable(table: Table) {
			if (this.dmsSys.EnableGSTPrp) return;
			const pcSlevaPoId = cellNames(table).PC_SLEVA_PO;
			if (!pcSlevaPoId) {
				return;
			}
			const cenaCelkemReducer = (cenaCelkem: number, radek: Row) => cenaCelkem + radek.cells[pcSlevaPoId];
			this.CenaCelkem = table.rows.reduce(cenaCelkemReducer, 0);
		},
	},
	methods: {
		async handleOrderSaved({ zakazkaId }: { zakazkaId: number }) {
			if (!this.zakazkaExists || zakazkaId !== this.ZakazkaId) {
				return;
			}

			await this.fetchTableData([ZAKAZKA_PP]);
		},
		async onLaborCheckClick(event: any) {
			clearTimeout(this.timeout);
			this.timeout = setTimeout(() => {
				if (event.target.value.length >= 2) {
					this.dropdownList.LaborCodes = this.dropdownList.DefaultLaborList.filter((item: any) => (item.Text.includes(event.target.value.toUpperCase()))
					|| item.Value.includes(event.target.value.toUpperCase()));
				}
			}, 800);
		},
		handleSelection(rows: any) {
			this.multipleSelectionLaborRevert = rows.filter((x: Row) => this.laborCompletionStatusCheck(x));
			// if (this.canEditTableInReleaseMode) {
			// 	this.multipleSelection = rows.filter((x: Row) => !this.laborCompletionStatusCheck(x));
			// } else {
			 	this.multipleSelection = rows;
			// }

			if (this.multipleSelection.length !== 0) {
				this.showDelete = true;
				this.showRevert = true;
			} else {
				this.showDelete = false;
				this.showRevert = false;
			}
		},
		async deleteClick() {
			let canDelete: boolean = true;

			if (!this.multipleSelection || this.multipleSelection.length === 0) {
				showAlert({
					message: this.LocalizeChyboveHlasky('PLEASE_SELECT_LABORS'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return;
			}
			
			const markdeleteLabors: number[] = [];
			const laborId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.PP_ID;
			const servicePackageColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.SERVICE_PACKAGE_ID;
			const activityEndTimeColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.ACTIVITY_END_TIME;
			const lineItemStatusId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.LINE_ITEM_STATUS;
			const activityStartTimeColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.ACTIVITY_START_TIME;
			const hasInvalidSelection = this.multipleSelection.some((row: any) => {
				if (row.cells[servicePackageColId] !== null) {
					return true;
				}
				if (this.dmsSys.IsActivityEndTimePrp) {
					return row.cells[activityStartTimeColId] !== null || row.cells[activityEndTimeColId] !== null || row.cells[lineItemStatusId] !== null;
				}
				return false;
			});

			if (hasInvalidSelection) {
				canDelete = false;
				showAlert({
					message: this.LocalizeChyboveHlasky('PLEASE_SELECT_LABORS'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return;
			}

			// If labor is invoiced user can not delete the Labor Item.
			if (canDelete) {
				const laborInvoicedStatuses = await Promise.all(this.multipleSelection.map((row: any) => this.isAnyLabourInvoiced(this.ZakazkaId, row.cells[laborId], 'LABOUR')));
				const hasAnyInvoicedLabor = laborInvoicedStatuses.some((isInvoiced: boolean) => isInvoiced === true);
				if (hasAnyInvoicedLabor) {
					canDelete = false;
					showAlert({
						message: this.LocalizeChyboveHlasky('PLEASE_UNCHECK_INVOICED_LABORS_TO_DELETE'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					return;
				}
			}

			// If labor is sent to SAGA. User can not delete the Labor Item.
			if (canDelete) {			
				const isSagaSplitPartyExistsStatus = await Promise.all(this.multipleSelection.map((row: any) => this.isSagaSplitPartyExists(row.cells[laborId])));
				const hasAnySagaSplitPartyExists = isSagaSplitPartyExistsStatus.some((isExists: boolean) => isExists === true);
					if (hasAnySagaSplitPartyExists && this.IsOrderSentToSaga === true) {
						canDelete = false;
						showAlert({
							message: this.LocalizeChyboveHlasky('CANT_DELETE_LABOUR_SENT_TO_SAGA'),
							title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
							options: {
								type: 'info',
							},
						});
						return;
					}
			}

			this.multipleSelection.map((row: any) => markdeleteLabors.push(row.cells[laborId]));
			if (canDelete) {
				const confirmDelete = await this.showConfirm({
					message: this.LocalizeChyboveHlasky('SURE_TO_DELETE'),
					title: this.LocalizeChyboveHlasky('SURE_TO_DELETE_CONFIRM'),
					options: {
						confirmButtonText: this.Localize('Ano'),
						cancelButtonText: this.Localize('Ne'),
					},
				});
				if (confirmDelete) {
					await apiProvider.DeleteMultipleLabors(markdeleteLabors);
				}
			}
			await this.fetchTableData([ZAKAZKA_PP]);
			this.multipleSelection = [];
			this.showDelete = false;
		},
		async onRevertLaborClick() {
			let canDelete: boolean = false;
			const markdeleteLabors: number[] = [];
			const laborId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.PP_ID;
			const servicePackageColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.SERVICE_PACKAGE_ID;
			const activityEndTimeColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.ACTIVITY_END_TIME;
			const lineItemStatusId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.LINE_ITEM_STATUS;
			this.multipleSelectionLaborRevert.map((row: any) => {
				if (row.cells[servicePackageColId] !== null) {
					canDelete = true;
					return showAlert({
						message: this.LocalizeChyboveHlasky('ItemCannotDelete'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					return false;
				}
				markdeleteLabors.push(row.cells[laborId]);
			});

			const isLaborCompleted = this.dependentTables.ZakazkaPracovniPozice.rows.filter((row: Row) => markdeleteLabors
				.includes(row.cells[laborId]) && (row.cells[lineItemStatusId] !== null && row.cells[lineItemStatusId] !== false));

			let error = false;

			if (isLaborCompleted?.length !== markdeleteLabors?.length) {
				error = true;
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('Lo_Reversal_Not_Applicable') });
			}

			const { data: laborReturnCheck } = await zakazkaApiProvider.canRevertLabours(markdeleteLabors);
			const { data: isAllPartiesCreditNoteApproved } = await zakazkaApiProvider.isAllPartiesCreditNoteApproved(markdeleteLabors, this.ZakazkaId);
			if (markdeleteLabors.length === 0) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('notapplicableforRevert') });
			} else if (!laborReturnCheck && this.zakazkaStav === ZAKAZKA_STAV.UVOLNENA) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('laborReturnValidation') });
			} else if (!isAllPartiesCreditNoteApproved) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('Lo_Reversal_Not_Applicable') });
			} else if (!canDelete && !error) {
				const revertLaborconfirmation = await this.showConfirm({
					message: this.LocalizeChyboveHlasky('msgLaborRevertConfirmation'),
					title: getMessageType(MessageTypeStatus.WARNING),
				});
				if (revertLaborconfirmation) {
					await apiProvider.RevertLabors(markdeleteLabors);
					await this.fetchTableData([ZAKAZKA_PP]);
				}
			}

			this.showRevert = false;
		},
		booleanIcon(row: Row, columnId: number): string {
			return row.cells[columnId] ? 'el-icon-check' : 'el-icon-close';
		},
		canEditOrDelete(row: Row): boolean {
			const servicePackageColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.SERVICE_PACKAGE_ID;
			const activityEndTimeColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.ACTIVITY_END_TIME;
			const lineItemStatusId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.LINE_ITEM_STATUS;
			if (row.cells[servicePackageColId] !== null) {
				return false;
			}
			if (this.dmsSys.IsActivityEndTimePrp) {
				if (row.cells[activityEndTimeColId] !== null || row.cells[lineItemStatusId] !== null) {
					return false;
				}
			}
			return true;
		},
		onNoteInput(event: any, row: Row, columnId: number) {
			this.noteInput = event;
			row.cells[columnId] = event;
		},
		async showConfirmMessage(message: string) {
			return this.showConfirm({
				message: this.LocalizeChyboveHlasky(message),
				title: this.LocalizeChyboveHlasky('questionTitle'),
				options: {
					confirmButtonText: this.Localize('Ano'),
					cancelButtonText: this.Localize('Ne'),
				},
			});
		},
		async createRow() {
			if(!this.CanAddPartOrLabour) {
				showAlert({
						message: this.LocalizeChyboveHlasky('CANNOT_ADD_NEW_ITEM'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					return;
			}
			this.dropdownList.LaborCodes = this.dropdownList.DefaultLaborList.slice(0, 100);
			this.rowId = 0;
			this.isDiscountEditable = true;
			this.selectedLaborNumber = '';
			this.isElementEditable = true;
			this.canEditWarrantyPrice = true;
			if (this.zakazkaStav === ZAKAZKA_STAV.NABIDKA || this.ZakazkaDruh === ZAKAZKA_DRUH.PREVOD_ND)
			{
				this.canEditWarrantyPrice = false;
			}
			if (!this.canEditTableInReleaseMode) {
				if (this.dmsSys.WorkItemPrp && this.edit.IsAllItemLevelStatusEntered) {
					const areAllItemsCompleted = !await this.showConfirmMessage('IsAllItemCompleted');
					if (areAllItemsCompleted) return;
				}
			}
			(this.$refs.editableTable as any).createRow();
			this.localTimeUnit = MIN_FIELD_LEVEL;
			this.localLaborPrice = MIN_FIELD_LEVEL;
			this.localCostCenter = MIN_FIELD_LEVEL;

			// Pre-fill COST_CENTER in the new blank row using the previous row's value (if any).
			const existingRows: Row[] = this.dependentTables.ZakazkaPracovniPozice.rows;
			if (existingRows && existingRows.length > 0) {
				const costCenterColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.COST_CENTER;
				const previousRow: Row = existingRows[existingRows.length - 1];
				const previousCostCenter = previousRow?.cells?.[costCenterColId];
				if (previousCostCenter !== null && previousCostCenter !== undefined) {
					const editableTableRef: any = this.$refs.editableTable;
					if (editableTableRef && editableTableRef.rowModel && editableTableRef.rowModel.cells) {
						editableTableRef.rowModel.cells[costCenterColId] = previousCostCenter;
					}
					this.localCostCenter = previousCostCenter;
				}
			}
		},
		updateRows({ rows }: { rows: Row[] }) {
			this.dependentTables.ZakazkaPracovniPozice.rows = rows;
		},
		getLODetails(row: Row, columnId: number) {
			return row.cells[columnId];
		},
		async updateRow(rowUpdateData: {
			tableName: string;
			updateStatus: EditableStatus;
			rowId: number;
			row: Row;
		}) {
			const laborId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.PP_ID;
			const row: Row = this.pracovniPoziceTable.rows.find((item: Row) => item.cells[laborId] === rowUpdateData.rowId);
			if (rowUpdateData.updateStatus === EditableStatus.DELETED) {
				const servicePackageColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.SERVICE_PACKAGE_ID;
				const activityEndTimeColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.ACTIVITY_END_TIME;
				const lineItemStatusId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.LINE_ITEM_STATUS;
				const activityStartTimeColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.ACTIVITY_START_TIME;
				if (row.cells[servicePackageColId] !== null) {
					showAlert({
						message: this.LocalizeChyboveHlasky('ItemCannotDelete'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					return;
				}
				if (this.dmsSys.IsActivityEndTimePrp) {
					if (row.cells[activityStartTimeColId] !== null || row.cells[activityEndTimeColId] !== null || row.cells[lineItemStatusId] !== null) {
						showAlert({
							message: this.LocalizeChyboveHlasky('ItemCannotDelete'),
							title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
							options: {
								type: 'info',
							},
						});
						return;
					}
				}

				let canDelete: boolean = true;
				this.$store.commit(`${this.storeUri}/${START_LOADING}`);
				const laborInvoicedStatus = await this.isAnyLabourInvoiced(this.ZakazkaId, row.cells[laborId], 'LABOUR');
				this.$store.commit(`${this.storeUri}/${END_LOADING}`);
				if (laborInvoicedStatus) {
					canDelete = false;
					showAlert({
						message: this.LocalizeChyboveHlasky('ItemCannotDelete'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
				}

				// If labor is sent to SAGA. User can not delete the Labor Item.
				if (canDelete) {
					if (await this.isSagaSplitPartyExists(row.cells[laborId]) && this.IsOrderSentToSaga) {
						canDelete = false;
						showAlert({
							message: this.LocalizeChyboveHlasky('CANT_DELETE_LABOUR_SENT_TO_SAGA'),
							title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
							options: {
								type: 'info',
							},
						});
						return;
					}
				}
				
				if (canDelete) {
					const confirmDelete = await this.showConfirm({
						message: this.LocalizeChyboveHlasky('SURE_TO_DELETE'),
						title: this.LocalizeChyboveHlasky('SURE_TO_DELETE_CONFIRM'),
						options: {
							confirmButtonText: this.Localize('Ano'),
							cancelButtonText: this.Localize('Ne'),
						},
					});
					if (confirmDelete) {
						this.$store.commit(`${this.storeUri}/${START_LOADING}`);
						await apiProvider.DeleteLabor(row.cells[laborId]);
						await this.fetchTableData([ZAKAZKA_PP]);
						this.$store.commit(`${this.storeUri}/${END_LOADING}`);
					}
				}
			}
		},
		getLaborCode(row: Row, columnId: number) {
			const result: DropdownItem = this.dropdownList.LaborCodes.find(
				(item: DropdownItem) => item.Value === row.cells[columnId],
			)!;
			return result?.Value;
		},
		async onRowDiscountChange(value: string, columnId: number, updateCol: any, row: Row) {
			if (this.dmsSys.OrderDiscountPrp !== true) {
				updateCol(value, columnId);
				row.cells[columnId] = value;
				return true;
			}
			if(this.validateRowLevelDiscount(value, updateCol, row) === false) {
				return false;
			}
		},
		getServiceJob(row: Row, columnId: number) {
			const result: DropdownItem = this.dropdownList.ServiceJobForItems.find(
				(item: DropdownItem) => item.Value === parseInt(row.cells[columnId]),
			)!;
			return result?.Text;
		},
		getWorker(row: Row, columnId: number) {
			const result: DropdownItem = this.dropdownList.Workers.find(
				(item: DropdownItem) => item.Value === parseInt(row.cells[columnId]),
			)!;
			return result?.Text ?? row.cells[columnId];
		},
		getCostCenter(row: Row, columnId: number) {
			const result: DropdownItem = this.dropdownList.CostCenter.find(
				(item: DropdownItem) => item.Value === row.cells[columnId],
			)!;
			return result?.Text;
		},

		onTimeUnitLeave(value: any, columnId: number, row:Row) {
			if (value <= 0 || value === '') {
				this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('msgCorrectTu'),
					options: { type: 'error' },
					localizeMessage: false,
				});
				row.cells[columnId] = this.cancelLocalTimeUnit;
				return false;
			}
			if (value.toString().indexOf('.') != -1) {
				this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('msgCorrectTu'),
					options: { type: 'error' },
					localizeMessage: false,
				});
				row.cells[columnId] = this.cancelLocalTimeUnit;
				return false;
			}
			this.localTimeUnit = parseInt(value);
			row.cells[columnId] = value;
			return true;
		},

		async onTimeUnitChange(value: any, columnId: number, updateCol: any, row: Row) {
			const timeUnitIndex: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.CAS_JDN_POC;
			updateCol(value, timeUnitIndex);
			row.cells[columnId] = value;
			this.localTimeUnit = value;
		},

		async onLaborCodeChange(value: string, columnId: number, updateCol: any, row: Row) {
			updateCol(value, columnId);
			const result: any = this.dropdownList.LaborCodes.find(
				(item: any) => item.Value === value,
			)!;
			this.selectedLaborNumber = value;
			const descriptionColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.TEXT;
			const timeUnitColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.CAS_JDN_POC_CELK;
			const timeUnitIndex: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.CAS_JDN_POC;
			const laborPriceColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.PC_PP_SL_PRED;
			updateCol(result?.Text, descriptionColId);
			updateCol(result?.TimeUnit, timeUnitColId);
			updateCol(result?.TimeUnit, timeUnitIndex);
			this.localTimeUnit = result?.TimeUnit;
			this.cancelLocalTimeUnit = result?.TimeUnit;
			row.cells[timeUnitColId] = result?.TimeUnit;
			const priceWithoutGstCol: Column[] = this.dependentTables.ZakazkaPracovniPozice.columns
				.filter((item) => item.columnName === this.laborCols.PC_WITHOUT_GST || item.columnName === this.laborCols.PC_WITH_GST
					|| item.columnName === this.laborCols.PC_VC_DPH_NAD || item.columnName === this.laborCols.PC_BEZ_DPH_NAD);
			const costCenterColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.COST_CENTER;
			if (result?.TimeUnit > 0 && row.cells[costCenterColId] != null) {
				this.$store.commit(`${this.storeUri}/${START_LOADING}`);
				const { data: dataForPrice } = await apiProvider.getLaborPriceDetails(this.ZakazkaId!, value, null, null);
				row.cells[laborPriceColId] = dataForPrice;
				this.localLaborPrice = dataForPrice;
				this.$store.commit(`${this.storeUri}/${END_LOADING}`);
				priceWithoutGstCol.forEach(column => {
					const newColumn: Column = column!.columns!.find((item) => item.columnName === this.laborCols.PC_PP_SL_PRED)!;
					const colId: number = parseInt(newColumn?.columnId);
					row.cells[colId] = dataForPrice;
				});
			}
		},
		async onWorkerChange(value: string, columnId: number, updateCol: any, row: Row) {
			updateCol(value, columnId);
			const workerColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.WORKER_ID;
			updateCol(value, workerColId);
			const costCenterColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.COST_CENTER;
			if (value !== null) {
				const workerList: WorkersWithCostCenter = this.dropdownList.Workers.find(
					(item: WorkersWithCostCenter) => item.Value === parseInt(value),
				)!;
				updateCol(workerList?.CostCenter, costCenterColId);
				row.cells[costCenterColId] = workerList?.CostCenter;
				this.localCostCenter = workerList?.CostCenter!;

				const laborPriceColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.PC_PP_SL_PRED;
				const laborPriceId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.PP_NR;
			} else {
				updateCol(null, costCenterColId);
				row.cells[costCenterColId] = null;
				this.localCostCenter = MIN_FIELD_LEVEL;
			}
		},

		async onServiceJobChange(value: string, columnId: number, updateCol: any, row: Row) {
			if (value !== null) {
			 const newServiceJobId = parseInt(value);
			 this.$store.commit(`${this.storeUri}/${START_LOADING}`);

			 if (this.zakazkaStav === ZAKAZKA_STAV.UVOLNENA && this.IsOrderSentToSaga === true && await this.isSagaSplitPartyExistInServiceJob(newServiceJobId)) {
				 showAlert({
						message: this.LocalizeChyboveHlasky('Service_job_with_SAGA_Split'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
				  const previousServiceJobId = parseInt(row.cells[columnId]);
			  	  updateCol(previousServiceJobId, columnId);
				  row.cells[columnId] = previousServiceJobId;
				  this.$store.commit(`${this.storeUri}/${END_LOADING}`);
				  return;
				}
				const invoiceStatus = await this.isAnyServiceJobSplitPartyInvoiced(newServiceJobId, row);
				if (invoiceStatus.IsServiceJobPartyInvoiced) {
					showAlert({
						message: this.LocalizeChyboveHlasky('Invoice_Generated_For_SJ_Msg'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					const previousServiceJobId = parseInt(row.cells[columnId]);
					updateCol(previousServiceJobId, columnId);
					row.cells[columnId] = previousServiceJobId;
				} else if (invoiceStatus.IsPrimaryCustomerInvoiced) {
					showAlert({
						message: this.LocalizeChyboveHlasky('Primary_Customer_Invoiced_For_SJ_Msg'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					const previousServiceJobId = parseInt(row.cells[columnId]);
					updateCol(previousServiceJobId, columnId);
					row.cells[columnId] = previousServiceJobId;
				} else if (invoiceStatus.IsServiceJobViolatingDiscountLimit) {
					showAlert({
						message: this.LocalizeChyboveHlasky('Service_Job_Violates_Discount_Limit_Msg'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					const previousServiceJobId = parseInt(row.cells[columnId]);
					updateCol(previousServiceJobId, columnId);
					row.cells[columnId] = previousServiceJobId;
				} else if (this.isServiceJobSplitBillingAvailableForOrderType()) {
					updateCol(newServiceJobId, columnId);
					row.cells[columnId] = value;
				} else {
					showAlert({
						message: this.LocalizeChyboveHlasky('SJ_Split_Warning_Msg'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					
				} 
				if (!invoiceStatus.IsAnyDiscountPercentAndAmount){
					const discountPercentColId = this.dependentTables.ZakazkaPracovniPozice.cellNames!.DISCOUNT_PERCENT;
					const discountAmountColId = this.dependentTables.ZakazkaPracovniPozice.cellNames!.DISCOUNT_VAL;
					
					updateCol(0, discountPercentColId);
					updateCol(0, discountAmountColId);
					row.cells[discountPercentColId] = 0;
					row.cells[discountAmountColId] = 0;
				}
				this.$store.commit(`${this.storeUri}/${END_LOADING}`);
			} else {
				updateCol(null, columnId);
				row.cells[columnId] = null;
			}
		},

		async onWarrantyPriceChange(value: any, row: Row, columnId: number, updateCol: any) {
			updateCol(value, columnId);
			row.cells[columnId] = value;
		},
		async onWarrantyPriceLeave(value: any, row: Row, columnId: number, updateCol: any) {
			if (value === null || value < 0) {
				this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('invalidWarrantyPrice'),
					options: { type: 'error' },
					localizeMessage: false,
				});
				updateCol(this.warrantyPriceInput, columnId);
				row.cells[columnId] = this.warrantyPriceInput;
				return false;
			}
			updateCol(value, columnId);
			this.warrantyPriceInput = value;
			row.cells[columnId] = value;
			return true;
		},

		async onCostCenterChange(value: number, columnId: number, updateCol: any, row: Row) {
			updateCol(value, columnId);
			row.cells[columnId] = value;
			this.localCostCenter = value;
			const laborPriceColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.PC_PP_SL_PRED;
			const laborPriceId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.PP_NR;
			if (row.cells[laborPriceId] > 0) {
				this.$store.commit(`${this.storeUri}/${START_LOADING}`);
				const { data: dataForPrice } = await apiProvider.getLaborPriceDetailsWithCC(this.ZakazkaId!, row.cells[laborPriceId], value, this.localTimeUnit);
				row.cells[laborPriceColId] = dataForPrice;
				this.localLaborPrice = dataForPrice;
				updateCol(dataForPrice, laborPriceColId);
				this.$store.commit(`${this.storeUri}/${END_LOADING}`);
			}
		},
		async onEditRow({ rowIndex, row }: { rowIndex: number, row: Row }) {
			this.dropdownList.LaborCodes = this.dropdownList.DefaultLaborList.slice(0, 100);
			const timeUnitIndex: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.CAS_JDN_POC;
			this.cancelLocalTimeUnit = row.cells[timeUnitIndex];
			this.localTimeUnit = row.cells[timeUnitIndex];
			const costCenterColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.COST_CENTER;
			this.localCostCenter = row.cells[costCenterColId];
			this.cancelCostCenter = row.cells[costCenterColId];
			const laborNumberColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.PP_ID;
			const itemId = row.cells[laborNumberColId];
			this.rowId = itemId;
			const discountAmountColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.DISCOUNT_VAL;
			this.originalDiscountAmount = row.cells[discountAmountColId];
			const discountPercentColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.DISCOUNT_PERCENT;
			this.originalDiscountPercent = row.cells[discountPercentColId];
			this.discountAmountReverted = false;
			const laborNumberIndex: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.PP_NR;
			const loNumber: string = row.cells[laborNumberIndex].toString();
			this.selectedLaborNumber = loNumber;
			const warrantyPriceColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.LABOR_WARRANTY_PRICE;
			this.warrantyPriceInput = row.cells[warrantyPriceColId];
			this.cancelWarrantyPriceInput = row.cells[warrantyPriceColId];

			const priceWithoutGstCol: Column[] = this.dependentTables.ZakazkaPracovniPozice.columns.filter((item) => item.columnName === this.laborCols.PC_WITHOUT_GST
			|| item.columnName === this.laborCols.PC_WITH_GST
				|| item.columnName === this.laborCols.PC_VC_DPH_NAD || item.columnName === this.laborCols.PC_BEZ_DPH_NAD);
			priceWithoutGstCol.forEach(column => {
				const newColumn : Column = column!.columns!.find((item) => item.columnName === this.laborCols.PC_PP_SL_PRED)!;
				const colId : number = parseInt(newColumn?.columnId);
				if (!Number.isNaN(colId)) {
					this.localLaborPrice = row.cells[colId];
					this.cancelLocalLaborPrice = row.cells[colId];
				}
			});
			this.isDiscountEditable = true;
			this.isElementEditable = true;
			this.canEditWarrantyPrice = true;
			if (await this.isWarrantyOrGoodwillSplitExists(row)) {
				this.isDiscountEditable = false;
			}

			if (this.zakazkaStav === ZAKAZKA_STAV.UVOLNENA || this.zakazkaStav === ZAKAZKA_STAV.NABIDKA || this.ZakazkaDruh === ZAKAZKA_DRUH.PREVOD_ND)
			{
				this.canEditWarrantyPrice = false;
			}

			// US#7543 Don't edit line item if it contains Goodwill or Warranty splits and Order is in released state.
			if (this.zakazkaStav === ZAKAZKA_STAV.UVOLNENA && this.IsOrderSentToSaga === true && await this.isSagaSplitPartyExists(itemId)) {
				showAlert({
					message: this.LocalizeChyboveHlasky('ItemCannotEidt'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				this.isElementEditable = false;
				return;
			}
			const laborId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.PP_ID;
			const labour = await this.isAnyLabourInvoiced(this.ZakazkaId, row.cells[laborId], 'LABOUR');
			this.isElementEditable = !labour;
			this.isDiscountEditable = !labour;
			this.isDiscountEnabled = !labour;

			if (labour) {
				showAlert({
					message: this.LocalizeChyboveHlasky('ItemCannotEidt'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				this.isElementEditable = false;
			}
		},
		async isAnyLabourInvoiced(orederId: number, itemId: number, itemType:string) {
			const { data: isInvoiced } = await apiProvider.isPartOrLabourInvoiced(orederId, itemId, itemType);
			return isInvoiced;
		},
		async isSagaSplitPartyExists(itemId: number) {
			try {
				this.$store.commit(`${this.storeUri}/${START_LOADING}`);
				const response = await apiProvider.getSplitDetails(itemId, this.ZakazkaId!);
				const checkPartyType = (object:any) => (object.PartyType === SPLIT_PARTIES.Goodwill)
				|| object.PartyType === SPLIT_PARTIES.Warranty;
				const result = response?.data?.some(checkPartyType);
				return result;
			} finally {
				this.$store.commit(`${this.storeUri}/${END_LOADING}`);
			}
		},
		async isCostCenterSelected(row: Row) {
			const costCenterColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.COST_CENTER;
			const result: DropdownItem = this.dropdownList.CostCenter.find(
				(item: DropdownItem) => item.Value === row.cells[costCenterColId],
			)!;
			if (!result?.Text) {
				row.cells[costCenterColId] = null;
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('PLEASE_ENTER_REQUIRED_VALUES_FOR_LABOUR') });
			}
		},
		calculateTotalDiscount(row: Row) : number {
			const lineItemDiscountColId = this.dependentTables.ZakazkaPracovniPozice.cellNames?.DISCOUNT_PERCENT;
			const lineItemDiscountValue: number = row.cells[lineItemDiscountColId as number] || 0;
			this.totalDiscount = lineItemDiscountValue;
			return this.totalDiscount;
		},
		calculateDiscountValue(row: Row) {
			const loAfterDiscountesIndex = this.dependentTables.ZakazkaPracovniPozice.cellNames?.PC_PP_SL_PO;
			const loBeforeDiscountsIndex = this.dependentTables.ZakazkaPracovniPozice.cellNames?.PC_PP_SL_PRED;
			const totalDiscount: number = this.calculateTotalDiscount(row);
			const calculateDiscountAmount: number = row.cells[loBeforeDiscountsIndex as number] * (totalDiscount / 100);
			row.cells[loAfterDiscountesIndex as number] = +(row.cells[loBeforeDiscountsIndex as number] - calculateDiscountAmount).toFixed(2);
		},
		onDiscountRemoval(row: Row) {
			const billToIndex: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.BILL_TO!;
			const vatIndex: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.VAT!;
			const loAfterDiscountIndex: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.PC_PP_SL_PO!;
			const loAfterDiscountWithVATIndex: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.PC_PP_SL_PO_WITH_VAT!;
			const billToValue: number = parseInt(row.cells[billToIndex] || 0);
			if (billToValue === 1) {
				row.cells[loAfterDiscountWithVATIndex] = row.cells[loAfterDiscountIndex] + (row.cells[loAfterDiscountIndex] * (row.cells[vatIndex] / 100));
			}
		},
		onDiscountAndLabourCodeChange(row: Row) {
			const loAfterDiscountsIndex = this.dependentTables.ZakazkaPracovniPozice.cellNames?.PC_PP_SL_PO;
			const loBeforeDiscountsIndex = this.dependentTables.ZakazkaPracovniPozice.cellNames?.PC_PP_SL_PRED;
			row.cells[loAfterDiscountsIndex as number] = this.localLaborPrice;
			row.cells[loBeforeDiscountsIndex as number] = this.localLaborPrice;
			this.calculateDiscountValue(row);
		},
		async rowSaved({ row: newRow }: { row: Row }) {
			try {
				this.$store.commit(`${this.storeUri}/${START_LOADING}`);
				const serviceJobColIndex: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.SERVICE_JOB_NAME!;
				const newServiceJobId = newRow.cells[serviceJobColIndex];

				const TuColumnIndex: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.CAS_JDN_POC!;
				const TuColumnValue = newRow.cells[TuColumnIndex];
				const laborPriceIndex: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.PC_PP_SL_PRED;
				const costCenterIndex: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.COST_CENTER;
				const costCenterId: number = newRow.cells[costCenterIndex];
				let laborPrice: number = newRow.cells[laborPriceIndex] ?? 0;
				const laborNumberIndex: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.PP_NR;

			
				if (costCenterId !== null) {
					const { data: lbrPrice } = await apiProvider.getLaborPriceDetailsWithCC(this.ZakazkaId!, newRow.cells[laborNumberIndex], costCenterId, this.localTimeUnit);
					laborPrice = lbrPrice;
				} else {
					const { data: lbrPrice } = await apiProvider.getLaborPriceDetails(this.ZakazkaId!, newRow.cells[laborNumberIndex], null, this.localTimeUnit);
					laborPrice = lbrPrice;
				}
				this.localLaborPrice = laborPrice;
				newRow.cells[laborPriceIndex] = laborPrice;
				newRow.cells = { ...newRow.cells, [laborPriceIndex]: laborPrice };				

				this.onTimeUnitLeave(TuColumnValue, TuColumnIndex, newRow);
				if (newServiceJobId! > 0 && await this.isWarrantyOrGoodwillExistInServiceJobSplit(newServiceJobId)) {
					showAlert({
						message: this.LocalizeChyboveHlasky('Zero_Discount_Warning_Msg'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					const discountColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.DISCOUNT_PERCENT!;
					newRow.cells[discountColId] = 0;
				}
				//this.onDiscountAndLabourCodeChange(newRow);
				this.onDiscountRemoval(newRow);
				const costCenterColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.COST_CENTER;
				newRow.cells[costCenterColId] = this.localCostCenter;
				const priceWithoutGstCol: Column[] = this.dependentTables.ZakazkaPracovniPozice.columns.filter((item) => item.columnName === this.laborCols.PC_WITHOUT_GST
				|| item.columnName === this.laborCols.PC_WITH_GST
					|| item.columnName === this.laborCols.PC_VC_DPH_NAD || item.columnName === this.laborCols.PC_BEZ_DPH_NAD);
				priceWithoutGstCol.forEach(column => {
					const newColumn: Column = column!.columns!.find((item) => item.columnName === this.laborCols.PC_PP_SL_PRED)!;
					const colId: number = parseInt(newColumn?.columnId);
					newRow.cells[colId] = this.localLaborPrice;
				});

				const discPerIndex: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.DISCOUNT_PERCENT;
				if (
					newRow.cells[discPerIndex]! < MIN_DISCOUNT_LIMIT
					|| newRow.cells[discPerIndex]! > MAX_DISCOUNT_LIMIT
				) {
					newRow.cells[discPerIndex] = MIN_FIELD_LEVEL;
					return this.showErrorAlert({
						// Using Predefined message
						message: this.LocalizeChyboveHlasky('MSGmsgDiscountShouldBe0To100'),
						options: { type: 'error' },
						localizeMessage: false,
					});
				}
				this.rowId = newRow.cells[this.dependentTables.ZakazkaPracovniPozice.cellNames!.PP_ID];
				this.laborValue = newRow.cells[this.dependentTables.ZakazkaPracovniPozice.cellNames!.PC_PP_SL_PO];
				this.dialogHeaderText = newRow.cells[this.dependentTables.ZakazkaPracovniPozice.cellNames!.TEXT];
				this.Sleva = newRow.cells[this.dependentTables.ZakazkaPracovniPozice.cellNames!.DISCOUNT_PERCENT];
				this.DiscountVal = newRow.cells[this.dependentTables.ZakazkaPracovniPozice.cellNames!.DISCOUNT_VAL];
				this.TotDiscPercentLabor = this.Sleva;
				// const laborNumberIndex: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.PP_NR;
				const loNumber: string = newRow.cells[laborNumberIndex].toString();
				this.selectedLaborNumber = loNumber;
				// On first-time labour insertion with a selected service job, validate split-party discount limits.
				if (!(this.rowId > 0) && newServiceJobId! > 0) {
					const { data: insertionValidationMessage } = await apiProvider.validateServiceJobWhileLaborInsertion(
						newServiceJobId,
						this.ZakazkaId!,
						loNumber,
						costCenterId ?? null,
						this.localTimeUnit ?? null,
						this.loggedUser.DiscountLimitConfigData?.LaborItemPer ?? 0,
					);
					if (insertionValidationMessage) {
						this.showErrorAlert({
							message: this.LocalizeChyboveHlasky(insertionValidationMessage),
							options: { type: 'error' },
							localizeMessage: false,
						});
						newRow.cells[serviceJobColIndex] = null;
						return false;
					}
				}
				if (this.rowId > 0) {
					const validationResponse = await zakazkaApiProvider.validateGrossDiscountAmountForSplitParties(
						this.ZakazkaId!,
						this.rowId,
						LABOUR,
						this.DiscountVal ?? 0,
						this.loggedUser.DiscountLimitConfigData?.LaborItemPer ?? 0,
						0,
						0,
					);
					const validationMessage: string = validationResponse?.data;
					if (validationMessage) {
						this.showErrorAlert({
							message: this.LocalizeChyboveHlasky(validationMessage),
							options: { type: 'error' },
							localizeMessage: false,
						});
						// Revert to the original value only on the first validation failure, keep user input on subsequent failures
						if (!this.discountAmountReverted) {
							newRow.cells[this.dependentTables.ZakazkaPracovniPozice.cellNames!.DISCOUNT_VAL] = this.originalDiscountAmount;
							newRow.cells[this.dependentTables.ZakazkaPracovniPozice.cellNames!.DISCOUNT_PERCENT] = this.originalDiscountPercent;
							this.discountAmountReverted = true;
						}
						this.$nextTick(() => {
							const editableTable: any = this.$refs.editableTable;
							const rowIndex = editableTable.editTableRows.indexOf(newRow);
							if (rowIndex >= 0) {
								editableTable.editRow(rowIndex, newRow);
							}
						});
						return false;
					}
				}

				if (this.rowId <= 0) {
					if (this.DiscountVal! > this.localLaborPrice) {
						this.showErrorAlert({ message: this.LocalizeChyboveHlasky('DiscountCannotBeLarger') });
						newRow.cells[this.dependentTables.ZakazkaPracovniPozice.cellNames!.DISCOUNT_VAL] = null;
						this.$nextTick(() => {
							const editableTable: any = this.$refs.editableTable;
							const rowIndex = editableTable.editTableRows.indexOf(newRow);
							if (rowIndex >= 0) {
								editableTable.editRow(rowIndex, newRow);
							}
						});
						return false;
					}
				}

				this.insertDiscount(newRow);
				await this.isCostCenterSelected(newRow);
			}
			finally {
				this.$store.commit(`${this.storeUri}/${END_LOADING}`);
			}
		},
		rowCancel(row: any) {
			if (row !== undefined && row.row !== undefined) {
				const timeUnitIndex: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.CAS_JDN_POC;
				const timeUnitColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.CAS_JDN_POC_CELK;
				const warrantyPriceColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.LABOR_WARRANTY_PRICE;
				this.localTimeUnit = this.cancelLocalTimeUnit;
				row.row.cells[timeUnitIndex] = this.cancelLocalTimeUnit;
				row.row.cells[timeUnitColId] = this.cancelLocalTimeUnit;
				const priceWithoutGstCol: Column[] = this.dependentTables.ZakazkaPracovniPozice.columns.filter((item) => item.columnName === this.laborCols.PC_WITHOUT_GST || item.columnName === this.laborCols.PC_WITH_GST
					|| item.columnName === this.laborCols.PC_VC_DPH_NAD || item.columnName === this.laborCols.PC_BEZ_DPH_NAD);
				this.localLaborPrice = this.cancelLocalLaborPrice;
				const costCenterColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.COST_CENTER;
				this.localCostCenter = this.cancelCostCenter;
				row.row.cells[costCenterColId] = this.cancelCostCenter;
				priceWithoutGstCol.forEach(column => {
					const newColumn: Column = column!.columns!.find((item) => item.columnName === this.laborCols.PC_PP_SL_PRED)!;
					const colId: number = parseInt(newColumn?.columnId);
					row.row!.cells[colId] = this.cancelLocalLaborPrice;
				});
				this.warrantyPriceInput = this.cancelWarrantyPriceInput;
				row.row.cells[warrantyPriceColId] = this.cancelWarrantyPriceInput;
			}
		},
		getLocalizedText(text: string) {
			return this.LocalizePopisPoli(text);
		},
		onSplitSharesDialogClosed() {
			this.loading = false;
		},
		isSplitBillingAvailableForOrderType(): boolean {
			return (this.ZakazkaDruh === ZAKAZKA_DRUH.PRODEJ_ZBOZI || this.ZakazkaDruh === ZAKAZKA_DRUH.DILENSKA);
		},
		isPartyLevelDiscountEnabled(row: Row, columnId: number): boolean {
			const currentRowId = row.cells[this.dependentTables.ZakazkaPracovniPozice.cellNames!.PP_ID];
			if(!(currentRowId > 0)) {
				return false;
			}
			const isPartyLevelDiscEnabledColId = this.dependentTables.ZakazkaPracovniPozice?.cellNames?.IS_PARTY_LEVEL_DISCOUNT_ENABLE;
			const discountColId = this.dependentTables.ZakazkaPracovniPozice?.cellNames?.DISCOUNT_PERCENT;
			if (isPartyLevelDiscEnabledColId === undefined || isPartyLevelDiscEnabledColId === null) {
				return false;
			}
			if (discountColId === undefined || discountColId === null) {
				return false;
			}
			
			const discountValue = row.cells[discountColId];

			const isPartyLevelDiscEnabled = row.cells[isPartyLevelDiscEnabledColId];
			// Treat an explicitly entered 0 the same as any other entered discount value, don't mark it as MIXED
			if ((discountValue !== null && discountValue !== undefined && discountValue !== '' && !Number.isNaN(+discountValue))) {
				return false;
			} else if (isPartyLevelDiscEnabled === false){
				return false;
			} else {
				return true
			}
		},
		redirectToSplitBilling(): boolean {
			return (this.zakazkaStav !== ZAKAZKA_STAV.UZAVRENA && this.isEditMode);
		},
		canRevertLO(): boolean {
			return ((this.zakazkaStav === ZAKAZKA_STAV.OTEVRENA || this.zakazkaStav === ZAKAZKA_STAV.UVOLNENA) && this.isEditMode);
		},
		async cellClick(row: any, column: any, cell: any) {
			if (this.isSplitBillingAvailableForOrderType()) {
				const cols : number[] = [];
				const priceWithoutGstCol: Column[] = this.dependentTables.ZakazkaPracovniPozice.columns.filter((item) => item.columnName === this.laborCols.PC_WITHOUT_GST || item.columnName === this.laborCols.PC_WITH_GST || item.columnName === this.laborCols.PC_VC_DPH_NAD || item.columnName === this.laborCols.PC_BEZ_DPH_NAD);
				priceWithoutGstCol.forEach(col => {
					cols.push(parseInt(col!.columns!.find((item) => item.columnName === this.laborCols.PC_PP_SL_PO)!?.columnId));
				});
				const labourNumberColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.PP_ID;
				const totalDiscount: number = this.calculateTotalDiscount(row);
				const timeUnitColId = this.dependentTables.ZakazkaPracovniPozice.cellNames!.CAS_JDN_POC;
				const labourCodeColId = this.dependentTables.ZakazkaPracovniPozice.cellNames!.PP_NR;

				if (this.redirectToSplitBilling() && cols.includes(column)) {
					const itemId = row.cells[labourNumberColId];
					// US#7543 Don't allow splitting if it contains Goodwill or Warranty splits already and Order is in released state.
					//if (this.zakazkaStav === ZAKAZKA_STAV.UVOLNENA && await this.isSagaSplitPartyExists(itemId)) {
						//return;
					//}
					openList(SPLIT_BILLING, {
						filter: {
							ItemType: LABOUR,
							ServiceOrderId: this.ZakazkaId,
							ItemId: itemId,
							Modified: totalDiscount,
							OrderStatus: this.zakazkaStav,
							LabourCode: row.cells[labourCodeColId],
							TimeUnit: row.cells[timeUnitColId],
							Saga2Prp: this.Saga2Prp,
							IsOrderSentToSaga: this.IsOrderSentToSaga,
						},
					}, { ServiceOrderId: this.ZakazkaId, ItemId: itemId, ItemType: LABOUR, Modified: totalDiscount, OrderStatus: this.zakazkaStav, LabourCode: row.cells[labourCodeColId], TimeUnit: row.cells[timeUnitColId], Saga2Prp: this.Saga2Prp, IsOrderSentToSaga: this.IsOrderSentToSaga });
				} else if (column === this.dependentTables.ZakazkaPracovniPozice.cellNames!.BILL_TO) {
					const itemId = row.cells[labourNumberColId];
					this.table = [];
					this.getSplitShareDetails(itemId);
					this.showSplitSharesDialog = true;
				}
			}
		},

		async getSplitShareDetails(itemId: number | null) {
			this.loading = true;
			const response = await apiProvider.getSplitDetails(itemId, this.ZakazkaId!);
			this.loading = false;
			this.table = response?.data;
		},
		decorateCells({ row, column }: { row: Row, column: any }) {
			if (this.isSplitBillingAvailableForOrderType()) {
				if ((this.redirectToSplitBilling() && column.label === this.LocalizePopisPoli('PC_PP_SL_PO') && !this.laborCompletionStatusCheck(row))
					|| column.label === this.LocalizePopisPoli('BILL_TO')) {
					return { color: 'Blue', cursor: 'pointer', textDecoration: 'underline' };
				}
			}
		},
		labourDiscount(event: any, cells: any) {
			const data = getColumnsRowMapObject(this.dependentTables.ZakazkaPracovniPozice.columns, cells);
			this.applyDiscount = true;
			this.showCancelOrderDialog = true;
			this.rowId = data.ID;
			this.laborValue = cells[this.dependentTables.ZakazkaPracovniPozice.cellNames!.PC_PP_SL_PO];
			this.dialogHeaderText = cells[this.dependentTables.ZakazkaPracovniPozice.cellNames!.TEXT];
			this.Sleva = cells[this.dependentTables.ZakazkaPracovniPozice.cellNames!.DISCOUNT_PERCENT];
			this.DiscountVal = cells[this.dependentTables.ZakazkaPracovniPozice.cellNames!.DISCOUNT_VAL];
		},
		async insertDiscount(row: Row) {
			const DiscountPerColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.DISCOUNT_PERCENT;
			// if (this.edit.DiscountVal! > this.laborValue) {
			// 	row.cells[DiscountPerColId] = MIN_FIELD_LEVEL;
			// 	this.showErrorAlert({
			// 		message: this.LocalizeChyboveHlasky('errSlevaAbs'),
			// 		options: { type: 'error' },
			// 		localizeMessage: false,
			// 	});
			// 	return;
			// }
			const checkForDiscount = await this.checkForDiscountLimit('LI');
			if (!checkForDiscount) {
				row.cells[DiscountPerColId] = MIN_FIELD_LEVEL;
			}
		},
		onPracovniPoziceClick() {
			openList(NAME, { filter: { ZakazkaId: this.ZakazkaId } });
		},
		canEditRow(row: Row) {
			if (this.isZpracuj && !this.canEditTableInReleaseMode) {
				return false;
			}
			const servicePackageColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.SERVICE_PACKAGE_ID;
			const activityEndTimeColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.ACTIVITY_END_TIME;
			const lineItemStatusId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.LINE_ITEM_STATUS;
			if (this.dmsSys.IsActivityEndTimePrp) {
				if (row.cells[servicePackageColId] !== null) {
					return false;
				}
				if (row.cells[activityEndTimeColId] !== null || row.cells[lineItemStatusId] !== null) {
					return false;
				}
			}
			return true;
		},
		editClick(event: any) {
			if (this.dmsSys.IsActivityEndTimePrp === true) {
				if (event.data.SERVICE_PACKAGE_ID !== null) {
					showAlert({
						message: this.LocalizeChyboveHlasky('ItemCannotEidt'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					return;
				}
				if (event.data.ACTIVITY_END_TIME!) {
					showAlert({
						message: this.LocalizeChyboveHlasky('ItemCannotEidt'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					return false;
				}
			}
			openEdit(NAME, PageMode.EDIT, { props: true, id: event.data.ID });
			return true;
		},
		/**
		 * This table is being retrieved from BE class ZakazkaCiziVykonyController which inturn implements BaseCrudGridSelectGridFacade,
		 * so it is not possible to override GridSchema method(BaseCrudGridFacade class).
		 * This method is used to retrieve grid columns in which we can write column-hide logic .
		 * So keeping column-hide logic as is in FE.
		 */
		disableColumns(table: Table | Column) {
			_.forEach(table.columns, (col) => {
				if (col.columnName === 'BILL_TO') {
					col.iconClass = 'el-icon-info';
				}
				if (_.has(col, 'columns')) {
					this.disableColumns(col);
				}
			});
		},
		async updateDiscount() {
			if (this.edit.TotDiscValLabor! > this.CenaCelkem!) {
				this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('DiscountCannotBeLarger'),
					options: { type: 'error' },
					localizeMessage: false,
				});
				this.TotDiscPercentLabor = MIN_FIELD_LEVEL;
				return;
			}
			if (
				this.TotDiscPercentLabor! < MIN_DISCOUNT_LIMIT
				|| this.TotDiscPercentLabor! > MAX_DISCOUNT_LIMIT
			) {
				this.TotDiscPercentLabor = MIN_FIELD_LEVEL;
				return this.showErrorAlert({
					// Using Predefined message
					message: this.LocalizeChyboveHlasky('MSGmsgDiscountShouldBe0To100'),
					options: { type: 'error' },
					localizeMessage: false,
				});
			}
			const checkForDiscount = await this.checkForDiscountLimit('');
			if (!checkForDiscount) {
				this.TotDiscPercentLabor = MIN_FIELD_LEVEL;
				return;
			}

			this.$store.commit(`${this.storeUri}/${START_LOADING}`);
			await zakazkaApiProvider.updateLabourDiscount(this.ZakazkaId, this.TotDiscPercentLabor, this.TotDiscValLabor);
			this.showDiscountSection = false;
			this.$store.commit(`${this.storeUri}/${END_LOADING}`);
			this.CenaCelkem = (await zakazkaApiProvider.getPrice(this.ZakazkaId!)).data;
		},
		onApplyDiscountClick() {
			if (this.pracovniPoziceTable.rows.length > 0) {
				this.showDiscountSection = true;
			} else {
				this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('NoLaborAdded'),
					options: { type: 'error' },
					localizeMessage: false,
				});
			}
		},
		async onDiscountChange() {
			if (this.dmsSys.OrderDiscountPrp && (this.TotDiscPercentLabor !== null && this.TotDiscValLabor !== null)) {
				if (this.VyrobekvozOzn !== VehicleBrand.SKODA) {
					this.showErrorAlert({ message: 'anyOneTypeDiscountAllowed' });
					this.TotDiscPercentLabor = null;
					this.TotDiscValLabor = null;
				} else {
					const isValid = await this.showConfirmPokracovat('bothDiscountMessage');
					if (!isValid) {
						this.TotDiscPercentLabor = null;
						this.TotDiscValLabor = null;
					}
				}
			}
		},
		checkForDiscountLimit(Level: string = '') {
			if (this.dmsSys.OrderDiscountPrp !== true) return true;
			let errormsg = null;
			if (this.loggedUser.DiscountLimitConfigData === null) errormsg = this.LocalizeChyboveHlasky('msgNotPerToAplyDisc');
			else {
				errormsg = this.validateDiscount(
					this.loggedUser.DiscountLimitConfigData.LaborItemTotalPer,
					Level,
				);
				if (Level === 'LI') {
					errormsg = this.validateDiscount(
						this.loggedUser.DiscountLimitConfigData.LaborItemPer,
						Level,
					);
				}
			}
			if (errormsg !== null) {
				this.showErrorAlert({
					message: `${errormsg}${this.LocalizeAndReplace(this.LocalizePopisostatni(Level === 'LI'
						? 'LABOR_ITEM' : 'LABOR_ITEM_TOTAL'), { key: this.LocalizePopisostatni('Level_Limit'), value: '' }).toLowerCase()}.`,
					options: { type: 'error' },
					localizeMessage: false,
				});
				return false;
			}
			return true;
		},
		validateDiscount(discountper: number, Level: string) {
			let errormsg = null;
			if ((discountper === 0 || this.loggedUser.DiscountLimitConfigData === null)) {
				errormsg = this.LocalizeChyboveHlasky('msgNotPerToAplyDisc');
			} else if (discountper > 0 && discountper < (this.TotDiscPercentLabor === null ? 0 : this.TotDiscPercentLabor)) {
				errormsg = this.LocalizeChyboveHlasky('msgNotAplyMoreThnDiscPer').replace('<DISC_PER>', `${discountper}%`);
			}
			return errormsg;
		},
		async showUploadLaborsClick() {
			if(!this.CanAddPartOrLabour) {
				showAlert({
						message: this.LocalizeChyboveHlasky('CANNOT_ADD_NEW_ITEM'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					return;
			}
			this.showLaborsDialog.visible = true;
		},
		handleLaborUploadChange(file: Record<string, any>) {
			this.laborFileList = [file];
		},
		handleLaborUploadRemove(file: File, fileList: []) {
			this.laborFileList = fileList;
		},
		async submitLaborUpload() {
			const startTime = performance.now();
			this.$store.commit(`${this.storeUri}/${START_LOADING}`);
			const { data: laborsInfo } = await apiProvider.uploadLabors(this.laborFileList[0], this.ZakazkaId, this.edit.Stav);
			this.laborFileList = [];
			if (laborsInfo) {
				showAlert({
					message: laborsInfo,
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'info' },
				});
			}
			this.showLaborsDialog.visible = false;
			this.fetchTableData([ZAKAZKA_PP]);
			this.$store.commit(`${this.storeUri}/${END_LOADING}`);
			const endTime = performance.now() - startTime;
			let seconds = parseFloat((endTime / 1000).toFixed(2));
			await apiProvider.logPerformance('OrderPrp', 'LO', BULK_UPLOAD, seconds);

			const { data: isLaborInProgress } = await zakazkaApiProvider.isLaborInProgress(this.ZakazkaId);
			if (isLaborInProgress) {
				const proceedWithSave = await this.showConfirm({
					message: this.LocalizeChyboveHlasky('LABOR_IN_PROGRESS_VALIDATION'),
					title: this.LocalizeChyboveHlasky('questionTitle'),
					options: {
						confirmButtonText: this.Localize('Ano'),
						cancelButtonText: this.Localize('Ne'),
					},
				});
				if (proceedWithSave) {
					const response = await zakazkaApiProvider.assignLaborOperations(this.ZakazkaId);
					await this.fetchTableData([ZAKAZKA_PP]);
					if (response?.data) {
						let displayMessage: string;
						if (response.data === 'WMS_CHIP_VAL') {
							displayMessage = this.LocalizeChyboveHlasky('WMS_CHIP_VAL');
						} else if (response.data === 'WMS_CHIP_OVERLAP_VAL') {
							displayMessage = this.LocalizeChyboveHlasky('WMS_CHIP_OVERLAP_VAL');
						} else {
							displayMessage = response.data + ' ' + this.LocalizeChyboveHlasky('IGNORED_LABOR_ASSIGNMENT');
						}

						showAlert({
							message: displayMessage,
							title: 'Notification',
							options: {
								type: 'info',
							},
						});
					}
				} else {
					await zakazkaApiProvider.autoAssignCancelled(this.ZakazkaId);
				}
			}
		},
		laborCompletionStatusCheck(row: Row): boolean {
			return (row.cells[this.dependentTables.ZakazkaPracovniPozice.cellNames!.LINE_ITEM_STATUS as number] !== null
			|| row.cells[this.dependentTables.ZakazkaPracovniPozice.cellNames!.ACTIVITY_END_TIME as number] !== null);
		},

		async isAnyServiceJobSplitPartyInvoiced(serviceJobId:number, row: Row) {
			const labourIdColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.PP_ID;
			const itemId = row.cells[labourIdColId];
			const discountLimitPercent = this.loggedUser.DiscountLimitConfigData.LaborItemPer ?? 0;
			const { data: isInvoiced } = await apiProvider.fetchInvoiceStatusOfServiceJobParty(this.ZakazkaId, serviceJobId, itemId, LABOUR, discountLimitPercent);
			return isInvoiced;
		},

		async isSagaSplitPartyExistInServiceJob(serviceJobId:number) {
			const { data: isSagaSplitPartyExists } = await zakazkaApiProvider.isSagaSplitsExistInServiceJobSplit(serviceJobId, this.ZakazkaId);
			return isSagaSplitPartyExists;
		},

		isServiceJobSplitBillingAvailableForOrderType(): boolean {
			return (this.ZakazkaDruh === ZAKAZKA_DRUH.DILENSKA);
		},
		async isWarrantyOrGoodwillSplitExists(row:Row) {
			try {
				this.$store.commit(`${this.storeUri}/${START_LOADING}`);
				const partNumberColId: number = this.dependentTables.ZakazkaPracovniPozice.cellNames!.PP_ID;
				const itemId = row.cells[partNumberColId];
				const response = await apiProvider.isWarrantyOrGoodwillSplitExists(itemId, this.ZakazkaId!, LABOUR);
				return response?.data;
			} finally {
				this.$store.commit(`${this.storeUri}/${END_LOADING}`);
			}
		},
		validateRowLevelDiscount(value: any, updateCol: any, row: Row): boolean {			
			const discountPercentColId = this.dependentTables.ZakazkaPracovniPozice.cellNames!.DISCOUNT_PERCENT;
			const discountAmountColId = this.dependentTables.ZakazkaPracovniPozice.cellNames!.DISCOUNT_VAL;
			const priceBeforeDiscountColId = this.dependentTables.ZakazkaPracovniPozice.cellNames!.PC_CEL_SL_PRED;
			//const campaignDiscountColId = this.dependentTables.ZakazkaPracovniPozice.cellNames!.CAMPAIGN_DISCOUNT_PERCENT;
			const discountPercent = value;
			const configuredDiscountLimit = this.loggedUser.DiscountLimitConfigData?.LaborItemPer ?? 0;
			//const campaignDiscount = row.cells[campaignDiscountColId];
			if (value === null || value === undefined || value === '') {
				return true;
			}
			const percentValue = +(_.defaultTo(discountPercent, 0));
			const totalDiscountPercent = +(_.defaultTo(discountPercent, 0));
			if (percentValue < 0 || percentValue > 100) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_DISCOUNT_PERCENT_INVALID') });
				updateCol(null, discountPercentColId);
				//updateCol(null, discountAmountColId);
				return false;
			}

			if (configuredDiscountLimit !== undefined && configuredDiscountLimit !== null && totalDiscountPercent > configuredDiscountLimit) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_DISCOUNT_PERCENT_EXCEEDS_LIMIT') });
				updateCol(null, discountPercentColId);
				//updateCol(null, discountAmountColId);
				return false;
			}

			updateCol(percentValue, discountPercentColId);
			//Reset discount amount to original value when discount percent is changed. This is to avoid any mismatch between discount percent and discount amount.
			//updateCol(this.originalDiscountAmount, discountAmountColId);
			if (percentValue >= 0) {
				updateCol(null, discountAmountColId);
			}
			
			return true;
		},

		onRowDiscountAmountLeave(value: any, row: Row, columnId: number, updateCol: any): Boolean {
			console.log(`onRowDiscountAmountLeave called at ${new Date().toISOString()}`);
			const discountPercentColId = this.dependentTables.ZakazkaPracovniPozice.cellNames!.DISCOUNT_PERCENT;
			const discountAmountColId = this.dependentTables.ZakazkaPracovniPozice.cellNames!.DISCOUNT_VAL;
			const priceBeforeDiscountColId = this.dependentTables.ZakazkaPracovniPozice.cellNames!.PC_PP_SL_PRED;
			const discountAmount = value;
			if (discountAmount === undefined) {
				return true;
			}
			if (discountAmount === null || discountAmount === undefined || discountAmount === '') {
				//updateCol(null, discountPercentColId);
				return false;
			}

			const amountValue = +discountAmount;
			if (Number.isNaN(amountValue) || amountValue < 0) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_DISCOUNT_AMOUNT_INVALID') });
				updateCol(null, discountAmountColId);
				//updateCol(null, discountPercentColId);
				return false;
			}

			// if (this.rowId <= 0) {
			// 	const loBeforeDiscount: number = +(row.cells[priceBeforeDiscountColId] ?? 1);
			// 	if (amountValue > loBeforeDiscount) {
			// 		this.showErrorAlert({ message: this.LocalizeChyboveHlasky('DiscountCannotBeLarger') });
			// 		updateCol(null, discountAmountColId);
			// 		return false;
			// 	}
			// }
			updateCol(amountValue, discountAmountColId);
			//Reset discount percent to original value when discount amount is changed. This is to avoid any mismatch between discount percent and discount amount.
			//updateCol(this.originalDiscountPercent, discountPercentColId);
			if (amountValue >= 0) {
				updateCol(null, discountPercentColId);
			}
			return true;
		},

		async isWarrantyOrGoodwillExistInServiceJobSplit(serviceJobId:number) {
			const response = await apiProvider.isWarrantyOrGoodwillExistInServiceJobSplit(this.ZakazkaId!, serviceJobId);
			return response?.data;
		},
	},
});
